// Path: ./src/contextApi/actions.ts
import {
  GfAdminUser,
  GfFlyerItemCategory,
  GfMerchantDto,
  GfPromotionTag,
  GfStoreDto,
  GfUnit,
} from "@swagger/typescript-fetch-goflyer";
import { AdminUser } from "./state";

/* eslint-disable no-unused-vars */
export enum ActionType {
  SetTest,
  SetUser,
  /**
   * in the near future, setUser will be replace with setGfAdminUser
   */
  SetGfAdminUser,
  SetPromotionTags,
  SetFlyerItemCategories,
  SetUnits,
  SetAdvancedSearchKeepSearchResults,
  SetAdvancedSearchSearchLimit,
  SetAdvancedSearchSearchFlyerItems,
}

export interface SetTest {
  type: ActionType.SetTest;
  payload: any;
}

export interface setUserPayload {
  isLoggedIn: boolean;
  jwtToken: string;
  parsedRoles?: any;

  createdAt?: string;
  email?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
  merchant?: GfMerchantDto[] | [];
  stores?: GfStoreDto[] | [];
  token?: string;
  updatedAt?: string;
  userName: string;
}

/**
 * in the near future, setUser will be replace with setGfAdminUser
 */
export interface SetUser {
  type: ActionType.SetUser;
  payload: AdminUser | undefined;
}

/**
 * in the near future, setUser will be replace with setGfAdminUser
 */
export interface SetGfAdminUser {
  type: ActionType.SetGfAdminUser;
  payload: GfAdminUser | undefined;
}

export interface SetPromotionTags {
  type: ActionType.SetPromotionTags;
  payload: GfPromotionTag[] | undefined;
}

export interface SetFlyerItemCategories {
  type: ActionType.SetFlyerItemCategories;
  payload: GfFlyerItemCategory[] | undefined;
}

export interface SetUnits {
  type: ActionType.SetUnits;
  payload: GfUnit[] | undefined;
}

export interface SetAdvancedSearchKeepSearchResults {
  type: ActionType.SetAdvancedSearchKeepSearchResults;
  payload: boolean;
}

export interface SetAdvancedSearchSearchLimit {
  type: ActionType.SetAdvancedSearchSearchLimit;
  payload: number;
}

export interface SetAdvancedSearchSearchFlyerItems {
  type: ActionType.SetAdvancedSearchSearchFlyerItems;
  payload: boolean;
}

export type GoFlyerAdminActions =
  | SetTest
  | SetUser
  | SetGfAdminUser
  | SetPromotionTags
  | SetFlyerItemCategories
  | SetUnits
  | SetAdvancedSearchKeepSearchResults
  | SetAdvancedSearchSearchLimit
  | SetAdvancedSearchSearchFlyerItems;
